import { ref } from 'vue'
import { useFormDataStore } from '../stores/formData'

export function useFormNavigation(options: { openModalFn: () => void }) {
  const formDataStore = useFormDataStore()
  const hasAnsweredFirstQuestion = ref(false)

  // 回答が更新されたときの処理
  function handleAnswerUpdate(id: number, answer: string | string[]) {
    formDataStore.updateAnswer(id, answer)

    // 1つ目の質問に回答したらモーダルを有効化
    if (formDataStore.currentQuestionIndex === 0 && !hasAnsweredFirstQuestion.value) {
      hasAnsweredFirstQuestion.value = true
      options.openModalFn() // モーダルを開く（この中で次の質問に進む）
    }
  }

  // 最後の質問の送信処理（Contact Formを表示するステップに進む）
  function handleLastQuestionSubmit(setupRequiredFieldsValidation: () => void) {
    // 全ての質問に回答したフラグをtrueに設定
    formDataStore.hasCompletedAllQuestions = true

    // フォームが表示された後に必須フィールドのバリデーションを設定
    setTimeout(setupRequiredFieldsValidation, 500)
  }

  return {
    hasAnsweredFirstQuestion,
    handleAnswerUpdate,
    handleLastQuestionSubmit,
  }
}
